import * as React from 'react'

function SvgIconDiscover(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="discover" aria-labelledby="t-discover d-discover">
        <title id="t-discover">{'Discover'}</title>
        <desc id="d-discover">
          {'A refracting telescope pointing at a starred sky'}
        </desc>
        <path d="M31.866 10.663L25.999.5a1.004 1.004 0 00-.866-.5c-.208 0-.412.065-.584.188l-7.08 5.089a1 1 0 00-.281 1.312l.039.069L8.09 13a1 1 0 00-.296 1.321l.047.082-7.425 5.34a1 1 0 00-.282 1.312l1 1.73a1 1 0 001.277.41l8.335-3.76.047.082c.184.312.52.5.867.5a.9.9 0 00.426-.104l1.527-.724A3.044 3.044 0 0013 21v.402l-3.964 9.912a.494.494 0 00.279.646.5.5 0 00.65-.274l3.213-8.033.829 7.457c.055.507.483.89.993.89h2a1 1 0 00.994-.891l.828-7.457 3.214 8.031a.49.49 0 00.649.271.49.49 0 00.271-.646L19 21.404V21a2.996 2.996 0 00-2.865-2.986l6.012-2.833.039.069a1.008 1.008 0 001.277.412l7.947-3.586a1.003 1.003 0 00.456-1.413zM2 22.285l-1-1.73 7.344-5.281 1.9 3.292L2 22.285zM18 21h-4a2 2 0 014 0zm-6.34-1.982l-3-5.188 9.068-6.293 3.916 6.784-9.984 4.697zm11.393-4.268l-5-8.66L25.133 1 31 11.163l-7.947 3.587zM4 2l.5 1.5L6 4l-1.5.5L4 6l-.5-1.5L2 4l1.5-.5zM5 9l.5 1.5L7 11l-1.5.5L5 13l-.5-1.5L3 11l1.5-.5zM13 0l.75 2.25L16 3l-2.25.75L13 6l-.75-2.25L10 3l2.25-.75z" />
      </g>
    </svg>
  )
}

export default SvgIconDiscover
